/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MonitoringIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Monitoring',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35 2H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h13v3a1 1 0 0 1-1 1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2a1 1 0 0 1-1-1v-3h13a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-3 15.883h-7.778a1.378 1.378 0 0 1-1.237-.83l-2.3-5-4.249 8.072a1.368 1.368 0 0 1-1.2.757H15.2a1.383 1.383 0 0 1-1.2-.83l-1.845-4-1.065 1.317a1.337 1.337 0 0 1-1.041.514H4V14h5l2.428-3.609a1.346 1.346 0 0 1 1.217-.5 1.4 1.4 0 0 1 1.061.818l1.61 3.5 4.249-8.072a1.405 1.405 0 0 1 1.235-.761 1.378 1.378 0 0 1 1.2.829L25.5 14H32Z"
    />
  </svg>`;
};
